define('common/ko/fn/asInt',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {
    ko.subscribable.fn.asInt = _.memoize(function(base) {
        base = base || 10;
        var self = this;
        return ko.pureComputed(function() {
            return parseInt(self(), base);
        });
    }, function(base) { return tools.objToHash([this, base]); } );
});

